import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

const TOKEN_KEY = "launchhub.authToken.v1";
const ADMIN_KEY = "launchhub.adminPasscode.v1";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const getAdminPasscode = () => sessionStorage.getItem(ADMIN_KEY);
export const setAdminPasscode = (p) => sessionStorage.setItem(ADMIN_KEY, p);
export const clearAdminPasscode = () => sessionStorage.removeItem(ADMIN_KEY);

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (config._admin) {
    const pass = getAdminPasscode();
    if (pass) config.headers["X-Admin-Passcode"] = pass;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !err.config?._skipAuthRedirect) {
      // Token invalid/expired — clear and let app reroute to /login
      clearToken();
    }
    return Promise.reject(err);
  }
);

// Helper used by Login/Register to display backend errors safely
export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const API_URL = API_BASE;

/**
 * Download a backend-stored document (e.g. generated Word docs).
 * Uses the authenticated `api` instance so the Bearer token is attached,
 * then creates an object URL and triggers the browser's native Save dialog.
 */
export async function downloadDocument(documentId, filename = "document.docx") {
  const resp = await api.get(`/documents/${documentId}/download`, {
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([resp.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
